var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "span",
            [_vm._v("Текст * ("), _c("TranslationIcon"), _vm._v(")")],
            1
          ),
          _c("QuillEditorVue", {
            attrs: {
              cols: 12,
              content: _vm.listItem.data.text,
              loading: _vm.isLoading,
              disabled: _vm.isLoading,
              isShowErrorMessage: true,
              errorText: _vm.errorMessages.text,
              "light-mode": "",
              title: "",
            },
            on: {
              input: function ($event) {
                return _vm.mixChangeListItemHandler($event, "text")
              },
              onChangeContent: function ($event) {
                return _vm.mixChangeListItemHandler(
                  $event,
                  "descriptionForMobile"
                )
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }